import { cerrarSesion } from "../utilities/Seguridad";
import axios from "axios";
import { useSelector } from "react-redux";
import React from 'react'; // Importa React

const URL = `${process.env.REACT_APP_URL}`

const sendAxios = async (config) => {

    let res = await axios(config)
        .then((response) => {
            if (response.data.error === 1)cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            let dat = []
            dat["error"] = 1;
            dat["mensaje"] = error.message;
            return dat;
        });
    return res;

};

const ApiFunctions = () => { // Componente funcional de React

    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    const authorization = `Bearer ${usuario.token}`;

    async function POST(recurso, accion, data) {

        let config = {
            method: 'POST',
            url: `${URL}/${recurso}/${accion}`,
            headers: { "Content-Type": "application/json", 'Authorization': authorization },
            data: JSON.stringify(data),
        };

        const response = await sendAxios(config);
        return response;
    }

    async function GET(recurso, accion, params) {
       
        let url = `${URL}/${recurso}/${accion}`;
        if (params && params.length > 0) {
            const paramString = params.map(param => param.toString()).join('/');
            url += '/' + paramString;
        }

        let config = {
            method: 'GET',
            url: url,
            headers: { 'Authorization': authorization }
        };

        const response = await sendAxios(config);
        return response;
    }

    async function PUT(recurso, accion, param, data) {
        let config = {
            method: 'PUT',
            url: `${URL}/${recurso}/${accion}/${param}`,
            headers: { "Authorization": authorization },
            data: JSON.stringify(data),
        };
        const response = await sendAxios(config);
        return response;
    }

    async function DELETE(recurso, accion, param) {
        let config = {
            method: 'DELETE',
            url: `${URL}/${recurso}/${accion}/${param}`,
            headers: { "Authorization": authorization },
        };
        const response = await sendAxios(config);
        return response;
    }

    return { POST, GET, PUT, DELETE }; // Devuelve las funciones como un objeto
};

export default ApiFunctions; // Exporta el componente